import type { StaffRole } from "./workflow";

export function normalizeRole(legacy: string): StaffRole {
  const v = legacy.toUpperCase().trim();
  if (
    v === "SUPERADMIN" ||
    v === "ADMIN" ||
    v === "REGISTRAR" ||
    v === "NURSE" ||
    v === "DOCTOR" ||
    v === "MKT"
  )
    return v;
  if (v === "SA") return "SUPERADMIN";
  if (v === "A") return "ADMIN";
  if (v === "MARKETING") return "MKT";
  if (v === "U") return "ADMIN";
  return "ADMIN";
}
